export default __webpack_public_path__ + "static/media/104.3a162d69.gif";